import * as React from 'react';
import styled from 'styled-components';

import colors from '../../colors';
import Title from './Title';

interface Props {
    locationName: string;
    ended: boolean;
    onClose: (e: React.MouseEvent<HTMLElement>) => any;
}

class Header extends React.Component<Props, {}> {
    private starter?: string;

    render() {
        const { onClose, locationName, ended } = this.props;
        return (
            <Wrapper className="conversations-header">
                {!ended && (
                    <CloseButton
                        className="conversations-control conversations-control-close"
                        type="button"
                        onClick={onClose}
                    >END
                    </CloseButton>
                )}
                <Flex>
                    <div>
                        <CarsLogo src="https://s3.amazonaws.com/conversations-files/global/cars_com-logo.png" />
                    </div>
                    <Title className="conversations-header-title" color="white">{locationName}</Title>
                </Flex>
            </Wrapper>
        );
    }
}

export default Header;

const Wrapper = styled.div`
    position: relative;
    text-align: center;
    margin-bottom: 2em;
    background-color: ${colors.carsPurple};
    margin-left: -20px;
    margin-right: -20px;
    & h1 {
        font-weight: 400;
    }
`;

const CloseButton = styled.button`
    padding: 0;
    line-height: initial;
    border-radius: 0;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 3px 8px;
    top: 5px;
    height: auto;
    font-weight: 400;
    letter-spacing: 1px;
    right: 5px;
    color: white;
    border: 1px solid white;
    transition: transform ease-in 0.1s;
    background-color: #4f3a7a;
    cursor: pointer;
    &:hover,
    &:focus {
        color: white;
        border-color: white;
        transform: scale(1.05);
    }
`;

const Flex = styled.div`
    display: flex;
    margin: 20px 30px 20px 20px;
    align-items: center;
`;

const CarsLogo = styled.img`
    display: block;
    width: 120px;
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/Cars/Header.tsx